// SEO 타입 상수
export const SEO_TYPE_COMMON = `0000`; // 공통
export const SEO_TYPE_PAGE = `0001`; // 개별페이지
export const SEO_TYPE_BOARD = `0002`; // 게시판
